module.exports = "/img/intro-bg-pc.0cb47a4b.png";